class RecommendationCardGenderImage extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    const carousel = this.closest('product-recommendation-carousel')
    const gender = carousel?.dataset?.genderContext
    if (gender !== 'male' && gender !== 'female') return

    const els = this.els
    const container = els.container?.element
    if (!container) return

    const images = (gender === 'male'
      ? container.dataset.maleImages
      : container.dataset.femaleImages
    )
      ?.split(',')
      .filter(Boolean)
    if (!images || images.length === 0) return

    const primary = container.querySelector('img')
    if (primary) {
      primary.srcset = ''
      primary.src = images[0]
    }

    if (images[1]) {
      const secondary = els.secondary?.element?.querySelector('img')
      if (secondary) {
        secondary.srcset = ''
        secondary.src = images[1]
      }
    }

    const link = this.parentNode.querySelector('.prd-Card_FauxLink')
    if (link) {
      const url = new URL(link.href)
      url.searchParams.set('gender', gender)
      link.href = url.href
    }
  }
}

if (!customElements.get('recommendation-card-gender-image')) {
  customElements.define(
    'recommendation-card-gender-image',
    RecommendationCardGenderImage,
  )
}
